// import queryString from "query-string";
import React, { useContext } from "react";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";

import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  CustomRadioButtonGroup,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";

import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import { approvedItem } from "../../../../values/radioOptionsItem";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [effect, setEffect] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });

  const { requestSchool, setRequestSchool } = useContext(Context.SchoolScreen);

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, requestSchool?.filters?.province],
    () =>
      api.get.common.getAllCity({
        provinceCode: requestSchool?.filters?.province?.Code,
      })
  );

  const { t } = useTranslation();

  // ================================ UseEffect Call ===============================

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );
  React.useEffect(() => {
    if (effect) {
      //   utils.urlGenerator({
      //     navigate,
      //     filters: selectedFilters,
      //     searchString: search ? String(search) : null,
      //   });
    } else setEffect(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")} hoverTitle={t("filter")}>
        {/* <p className="filter-labels">وضعیت آژانس:</p> */}
        {/* <CustomRadioButtonGroup
          menus={values.radioButtonItems.rbiIsBlock}
          selected={selectedFilters?.isBlock}
          onClick={(selected: iItem | null) => setSelectedFilters({...selectedFilters, isBlock: selected})}
        /> */}
        {userType === "ADMIN" && (
          <>
            <p className="filter-labels">{t("province")}:</p>
            <CustomDropdownSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              defaultItem={requestSchool?.filters?.province}
              onSelectItem={(event: IProvinceItem) =>
                setRequestSchool({
                  ...requestSchool,
                  filters: {
                    ...requestSchool?.filters,
                    province: event,
                    city: undefined,
                  },
                })
              }
              placeHolder={t("selectProvince")}
              isLoading={getAllProvince.isLoading}
            />

            <p className="filter-labels">{t("city")}:</p>
            <CustomDropdownSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              defaultItem={requestSchool?.filters?.city}
              onSelectItem={(event: ICityItem) =>
                setRequestSchool({
                  ...requestSchool,
                  filters: {
                    ...requestSchool?.filters,

                    city: event,
                  },
                })
              }
              placeHolder={t("selectCity")}
              isLoading={getAllCity.isLoading}
            />
          </>
        )}
        <label className="form-label">{t("schoolGender")}</label>
        <CustomDropdownSearch
          items={values.dropdownItems.SCHOOL_GENDER}
          itemName="name"
          defaultItem={requestSchool?.filters?.gender}
          onSelectItem={(event: any) =>
            setRequestSchool({
              ...requestSchool,
              filters: {
                ...requestSchool?.filters,

                gender: event,
              },
            })
          }
          placeHolder={t("selectGender")}
        />
        <p className="filter-labels">{t("status")} :</p>

        <CustomDropdownSearch
          items={approvedItem}
          itemName="name"
          defaultItem={
            approvedItem.find(
              (item) => item.value === selectedFilters?.isApproved
            ) as IItem
          }
          onSelectItem={(selected: IItem | null) => {
            setSelectedFilters({
              ...selectedFilters,
              isApproved: selected?.value,
            });
            setRequestSchool({
              ...requestSchool,
              filters: {
                ...requestSchool?.filters,
                isApproved: selected?.value,
              },
            });
          }}
          placeHolder={t("selectStatus")}
        />

        {/* <CustomRadioButtonGroup
          menus={approvedItem}
          selected={
            approvedItem.find(
              (item) => item.value === selectedFilters?.isApproved
            ) as IItem
          }
          onClick={(selected: IItem | null) => {
            setSelectedFilters({
              ...selectedFilters,
              isApproved: selected?.value,
            });
            setRequestSchool({
              ...requestSchool,
              filters: {
                ...requestSchool?.filters,
                isApproved: selected?.value,
              },
            });
          }}
        /> */}

        {userType === "ADMIN" && (
          <>
            {/* <p className="filter-labels">انتخاب اتحادیه و زیر مجموعه:</p> */}
            {/* <DropDownSearchSuperAgent
              defaultValue={selectedFilters?.superAgent?.name}
              onChangeSuperAgent={(selected: iItem | null) => {
                setSelectedFilters({...selectedFilters, superAgent: selected});
              }}
            /> */}
          </>
        )}
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestSchool({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

export default FilterAgent;
